export default __webpack_public_path__ + "static/conti-29f9856346d01ec18f8c38a7c4a04b90.jpg";